// extracted by mini-css-extract-plugin
module.exports = {"root":"Courses_root__1gx_S","info":"Courses_info__XDDrG","infoInner":"Courses_infoInner__13TF8","overlayBg":"Courses_overlayBg__Usap9"};